import { HttpContextToken, HttpErrorResponse } from "@angular/common/http";

export interface HttpError extends HttpErrorResponse {
  error: { code: HttpErrorCode; message: string };
}

export enum HttpErrorCode {
  FB_N_A = "free_bet_not_available",
  FB_N_F = "bet_free_bet_not_found",
}

export enum HttpErrorStatus {
  UNA = 401,
}

/*Auth Header*/
export const CAH = new HttpContextToken<boolean>(() => true);
/*Alert Error*/
export const CAE = new HttpContextToken<boolean>(() => false);
